import { toast } from 'react-toastify';

export default function ToastError({ content }) {
  const showToast = () => {
    toast.error(
      <div className="flex items-center gap-1">
        <img src="/svg/toast-error.svg" alt="error icon" />
        <span className="text-sm max-md:text-xs font-bold text-error">{content}</span>
      </div>,
      {
        className:
          '!bg-[#FFE9ED] !border-[1px] !border-error !rounded-lg !shadow-none !w-fit !max-w-[400px] max-md:!max-w-[300px]',
        bodyClassName: 'flex items-center !py-1.5',
      },
    );
  };

  return showToast();
}
